import './radio_button_simple.less';

import React from 'react';
import classNames from 'classnames';

import {
  CircleOpenIcon,
  CircleOpenDottedIcon,
} from 'zoomforth_component_lib/app_modern_icons.jsx';

import { SafeTipsy } from 'zoomforth_component_lib/tipsy.jsx';

const RadioButtonSimple = ({
  className,
  label,
  labelProps = {},
  checked,
  children,
  disabled,
  disabledReason,
  disabledReasonPlacement,
  tooltip,
  tooltipPlacement,
  variant,
  onClick,
  ...props
}) => {
  return (
    <SafeTipsy
      content={disabledReason || tooltip}
      placement={disabledReasonPlacement || tooltipPlacement}
    >
      <label
        {...labelProps}
        className={classNames(
          'zf-radio-button-simple-label',
          labelProps.className,
          { disabled }
        )}
      >
        <input
          type='radio'
          className={classNames('zf-radio-button-simple', className)}
          checked={checked}
          disabled={disabled}
          onChange={onClick}
          {...props}
        />
        {checked ? (
          <CircleOpenDottedIcon variant={variant} />
        ) : (
          <CircleOpenIcon variant={variant} />
        )}
        {label}
        {children}
      </label>
    </SafeTipsy>
  );
};

export default RadioButtonSimple;
